import aboutUs from "../assets/AboutUs.jpg";
import styled from "styled-components";

const AboutUs = () => {
  return (
    <>
      <AboutStyle>
        <div>
          <h1>ABOUT US</h1>
          <img src={aboutUs} alt="" />
        </div>
        <div>
          <p>
            Tech For Kids, a vertical of Insiqua Solutions, is an innovative
            alternative learning initiative that offers STEM and robotics
            education to children. <br />
            <br />
            Our mission is to make STEM education accessible and engaging for
            every child by providing hands-on, curriculum-based learning
            experiences using the Vex Robotics platform.
          </p>
          {/* <button>LEARN MORE</button> */}
        </div>
      </AboutStyle>
    </>
  );
};

const AboutStyle = styled.div`
  font-family: "Montserrat", sans-serif;
  height: 400px;
  margin: 70px 0;
  display: flex;
  width: 100%;
  overflow: hidden;

  > div:first-child {
    height: 300px;
    width: 100%;
    overflow: hidden;

    h1 {
      margin-bottom: 40px;
      font-size: 3rem;
       @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
      text-align: center;
    }
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
      height: 400px;
    }
  }
  > div:last-child {
    padding: 0 30px;
    width: 100%;
    height: 300px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 20px;

    p {
      line-height: 1.6;
      color: #555;
    }

    button {
      width: 200px;
      height: 60px;
      padding: 10px 20px;
      border: none;
      outline: none;
      background-color: ${({ theme }) => theme.color.orange};
      color: #fff;
      display: block;
    }
     @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
      height: 400px;
    }
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
      flex-direction: column;
      height: 700px;
      align-items: center;
      gap: 30px;
    }
`;

export default AboutUs;
